module.exports = __webpack_public_path__ + "static/media/jules_interiors-IG-2.34f1b5d7.PNG";